// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--3wZdZ"};